/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElForm as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { apiGetPlayerInfo } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'playerInfoModal',
  setup(__props, {
    expose: __expose
  }) {
    const playId = ref();
    const dialogVisible = ref(false);
    const playerInfo = ref();
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const getPlayerInfo = async () => {
      const res = await apiGetPlayerInfo({
        id: playId.value
      });
      if (res.code === 0) {
        playerInfo.value = res.data;
      }
    };
    const show = payload => {
      dialogVisible.value = true;
      if (payload.data) {
        playId.value = payload.data.id;
        getPlayerInfo();
      }
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_form = __unplugin_components_1;
      const _component_el_dialog = __unplugin_components_2;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "玩家详细信息",
        width: "600px",
        "before-close": handleClose
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色ID："
          }, {
            default: _withCtx(() => {
              var _unref2;
              return [_createElementVNode("span", null, _toDisplayString((_unref2 = _unref(playerInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.role_id), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "角色昵称："
          }, {
            default: _withCtx(() => {
              var _unref3;
              return [_createElementVNode("span", null, _toDisplayString((_unref3 = _unref(playerInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.nickname), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "区服ID："
          }, {
            default: _withCtx(() => {
              var _unref4;
              return [_createElementVNode("span", null, _toDisplayString((_unref4 = _unref(playerInfo)) === null || _unref4 === void 0 ? void 0 : _unref4.server_id), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "所属平台："
          }, {
            default: _withCtx(() => {
              var _unref5;
              return [_createElementVNode("span", null, _toDisplayString((_unref5 = _unref(playerInfo)) === null || _unref5 === void 0 ? void 0 : _unref5.platform), 1)];
            }),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});